/*** IMPORTS FROM imports-loader ***/
(function() {

define(['pip-common.utils'],
    function (pipCommonUtils) {

        var guids = {
          BAG_CAPACITY_DRY_VOLUME: 'f1623a39-e8f4-414a-a4e8-45124b8a8e2b',
          PRODUCT_WIDTH_FEET: '16c38a1e-3769-4531-9ad7-bd50c3074d09',
          PRODUCT_LENGTH_FEET: '76cb7dc4-b57f-4c45-a53b-fb8114a149da',
          SQUARE_FEET_PER_PIECE: 'e935e751-1f15-4986-afe3-acf05ba2e588',
          COVERAGE_AREA_SQUARE_FEET: '0352844d-49d7-49a4-8f17-eb605823f12b',
        };
        var groups = {
          FUNCTIONAL_DETAILS: 'functional details',
          SUPPLEMENTAL_DIMENSIONS: 'supplemental dimensions'
        };

        var getCompositeCoverage = function getCompositeCoverage(pip, attributeGroupLookups) {
          var attributes = attributeGroupLookups.map(function(lookup) {
            return +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, lookup.group, lookup.guid).split(' ')[0];
          }).filter( function(attribute) {
            return attribute;
          });
          if (attributes.length !== attributeGroupLookups.length){
            return null;
          };
          return attributes.reduce(function(product, attribute){
            return product * attribute;
          }, 1);
        };

        var getCalculatorConfig = function getCalculatorConfig(calculatorType, pip, viewModel, model) {
          switch(calculatorType) {
            case 'Flooring':
              return {
                calculatorType: 'Area',
                lineItemName: 'Area',
                dimensionNames: ['Length', 'Width'],
                uom: viewModel.displayUOM(model.unitOfMeasure),
                uomPlural: viewModel.pluralizeUnitOfMeasure(model.unitOfMeasure),
                productCategory: 'product',
                resultsDimension: model.caseUnitUom,
                pricePerUnit: model.specialPrice,
                areaPerUnit: model.unitsPerCase,
                coveragePerUnit: model.unitsPerCase,
                unitsPerCase: 1,
                displayOverage: viewModel.shouldApplyOverageMultiplier(),
                overage: model.overagePercentage
              }
            case 'Mulch/Soil':
              return {
                calculatorType: 'Volume',
                lineItemName: 'Space',
                uom: 'bag',
                uomPlural: 'bags',
                resultsDimension: 'cu. ft.',
                dimensionNames: [],
                productCategory: 'mulch/soil',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.FUNCTIONAL_DETAILS, guids.BAG_CAPACITY_DRY_VOLUME).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Landscape Rock':
              return {
                calculatorType: 'Volume',
                lineItemName: 'Space',
                uom: 'bag',
                uomPlural: 'bags',
                resultsDimension: 'cu. ft.',
                dimensionNames: [],
                productCategory: 'landscape rock',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.FUNCTIONAL_DETAILS, guids.BAG_CAPACITY_DRY_VOLUME).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Drywall':
              return {
                calculatorType: 'Area',
                lineItemName: 'Wall',
                uom: 'sheet',
                uomPlural: 'sheets',
                dimensionNames: ['Width', 'Length'],
                resultsDimension: 'sq. ft.',
                productCategory: 'drywall',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: getCompositeCoverage(pip, [{group: groups.SUPPLEMENTAL_DIMENSIONS, guid: guids.PRODUCT_WIDTH_FEET}, {group: groups.SUPPLEMENTAL_DIMENSIONS, guid: guids.PRODUCT_LENGTH_FEET}]),
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Wall Block':
              return {
                calculatorType: 'Area',
                lineItemName: 'Wall',
                uom: 'block',
                uomPlural: 'blocks',
                dimensionNames: ['Width', 'Height'],
                resultsDimension: 'sq. ft.',
                productCategory: 'product',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.FUNCTIONAL_DETAILS, guids.SQUARE_FEET_PER_PIECE).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Pavers':
              return {
                calculatorType: 'Area',
                lineItemName: 'Area',
                uom: 'piece',
                uomPlural: 'pieces',
                dimensionNames: ['Length', 'Width'],
                resultsDimension: 'sq. ft.',
                productCategory: 'product',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.FUNCTIONAL_DETAILS, guids.SQUARE_FEET_PER_PIECE).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Siding':
              return {
                calculatorType: 'Area',
                lineItemName: 'Wall',
                uom: 'panel',
                uomPlural: 'panels',
                dimensionNames: ['Length', 'Width'],
                resultsDimension: 'sq. ft.',
                productCategory: 'siding',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.SUPPLEMENTAL_DIMENSIONS, guids.COVERAGE_AREA_SQUARE_FEET).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Insulation':
              return {
                calculatorType: 'Area',
                lineItemName: 'Area',
                uom: 'unit',
                uomPlural: 'units',
                dimensionNames: ['Length', 'Width'],
                resultsDimension: 'sq. ft.',
                productCategory: 'insulation',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.SUPPLEMENTAL_DIMENSIONS, guids.COVERAGE_AREA_SQUARE_FEET).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            case 'Coverage':
              return {
                calculatorType: 'Area',
                lineItemName: 'Area',
                uom: 'unit',
                uomPlural: 'units',
                dimensionNames: ['Length', 'Width'],
                resultsDimension: 'sq. ft.',
                productCategory: 'product',
                pricePerUnit: model.specialPrice,
                coveragePerUnit: +pipCommonUtils.getAttributeValueByGroupAndGuid(pip, groups.SUPPLEMENTAL_DIMENSIONS, guids.COVERAGE_AREA_SQUARE_FEET).split(' ')[0],
                unitsPerCase: 1,
                displayOverage: true,
                overage: 10
              }
            default:
              return null;
          }
        };

        return {
            getCalculatorConfig: getCalculatorConfig
        }
    });

}.call(window));